<template>
    <router-link
        class="messageItem"
        :class="{
            deleteOn: deleteOn,
            sentMessage: isSentMessage,
            read: !message.pro_read && !isSentMessage,
        }"
        :to="{ name: messageLinkName, params: { id: message.id } }"
    >
        <div class="message">
            <span class="sender">
                <span v-if="message.group">{{ message.group.name }}</span>
                <span v-else-if="showFrom"
                    >{{ message.from.first_name }} {{ message.from.last_name }}</span
                >
                <span v-else>{{ message.to.first_name }} {{ message.to.last_name }}</span>

                <i class="date">{{ this.$date(message.created_at).format("ddd D MMM") }}</i>
            </span>

            <div class="content">
                {{ message.message }}
            </div>
        </div>

        <button
            @click.prevent="deleteMessage"
            v-if="deleteOn"
            class="button red"
            :class="{ sent: isSentMessage }"
            type="button"
            name="button"
        >
            <img class="minus" src="@/assets/minus.svg" />
        </button>
    </router-link>
</template>

<script>
export default {
    name: "message-item",
    props: {
        message: {
            type: Object,
            required: true,
        },
        showFrom: {
            type: Boolean,
            required: false,
        },
        deleteOn: {
            type: Boolean,
            required: false,
        },
        isSentMessage: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        messageLinkName() {
            if (this.user.type == "pro") {
                return "proMessage";
            } else {
                return "playerMessage";
            }
        },
    },
    methods: {
        deleteMessage() {
            this.$confirm("Are you sure you want to delete this message?", () => {
                if (!this.isSentMessage) {
                    this.$store.dispatch("deleteMessage", this.message);
                } else {
                    this.$emit("onDeleteMessage", this.message);
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.messageItem {
    background: white;
    padding: 17px;
    border-radius: $radius;
    margin-bottom: 10px;
    position: relative;
    color: $green_0;
    display: block;
    text-decoration: none;

    &.read {
        border-left: 5px solid #60c45c;
    }

    .message {
        padding: 0px !important;
        margin-bottom: 10px !important;
    }

    &.sentMessage {
        background: #e7efeb !important;
        .message {
            background: #e7efeb !important;
        }
    }

    &.deleteOn {
        padding-right: 73px;
    }

    &.unread {
        border-left: 4px solid $green_1;
    }

    .sender {
        display: block;
        margin-bottom: 10px;

        i {
            float: right;
            color: lighten(#000000, 80);
        }
    }
    .content {
        line-height: 1.5;
        font-weight: 200;
        a {
            text-decoration: none;
            color: $green_1;
        }
    }
    button {
        position: absolute;
        top: 0px;
        width: 64px;
        height: 100% !important;
        right: 0px;
        border-radius: 0px;
        border-top-right-radius: $radius;
        border-bottom-right-radius: $radius;
        width: 64px;
        padding: 0px;
        .minus {
            margin-left: 7px;
        }
        &:before {
            content: "";
            width: 12px;
            background: blue;
            height: 100%;
            position: absolute;
            top: 0px;
            left: 0px;
            background: white;
            border-top-right-radius: $radius;
            border-bottom-right-radius: $radius;
        }
        &.sent {
            &:before {
                background: #e7efeb;
            }
        }
    }
}
</style>
